// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const ErrorMessageWrapper: StatelessFunctionalComponent<*> = styled.div`
  position: relative;

  .ErrorMessage {

    &-container {
      margin: 25px 0px;
    }

    &-message-container {
      display: grid;
      text-align: center;
    }

    &-message-container-image {
      margin: 0 auto;
      padding: 40px 10px 10px;
    }

    &-message-image {
      width: 100%;
    }

    &-text {
      max-width: 440px;
      margin: 0 auto;
      font-size: 18px;
      padding: 20px;
      line-height: 1.5;
      text-align: center;
      color: var(--text-color-2);
    }

    &-button-container {
      cursor: pointer;
      text-align: center;
      margin: 0 auto;
      max-width: 400px;
      color: var(--white-color);
    }
  }

`;

export default ErrorMessageWrapper;
